import utils from 'lib/utils';

import ProgressService from 'services/course-handler-services/progress-service';
import Backbone from 'backbone';
import { LocalStorage } from 'backbone.localstorage';
import { webStorage } from 'services/data-handler-services/web-storage-service';
import $ from 'jquery';
import _ from 'lodash';
import { Models, Collections } from 'ef';

const localSync = {
  read: function (method, model, options) {
    const deferred = $.Deferred();
    if (typeof model.fileName === 'function') {
      model.fileName = model.fileName();
    }
    const localData = utils.tryRequire(`/local-data/${model.fileName}`);
    if (localData) {
      options.success(localData);
      if (options.parse) {
        model.parse(localData, options);
      }
    }
    return deferred.resolve();
  },
};

const customLocalSyncs = {
  ActivityProgressesCollection: {
    read: function (method, model, options) {
      const d = $.Deferred();
      const progresses = ProgressService.getLocalActivityProgresses();
      options.success(progresses);
      return d.resolve();
    },
  },
  Poll: {
    read: localSync.read,
    create: function (method, model, options) {
      const d = $.Deferred();
      const totals = [];
      model.get('answers').forEach(a => {
        totals.push({
          id: a.id,
          count: Math.floor(Math.random() * (500 - 1) + 1),
        });
      });
      model.set('totals', totals);
      options.success({ totals: totals });
      return d.resolve({ totals: totals });
    },
  },
  Module: {
    read: Backbone.localSync,
  },
  ModulesCollection: {
    read: Backbone.localSync,
  },
};

const SyncService = {
  initialize: function () {
    const self = this;
    const overrideSync = function (model, name) {
      if (customLocalSyncs[name] && model.prototype) {
        model.prototype.syncMethods = customLocalSyncs[name];
        self.storageFallback(model, name);

        model.prototype.sync = self.sync;
      } else if (model.prototype) {
        model.prototype.syncMethods = localSync;
        self.storageFallback(model, name);
        model.prototype.sync = self.sync;
      } else {
        _.each(model, overrideSync);
      }
    };

    _.each(Models, overrideSync);
    _.each(Collections, overrideSync);
  },
  sync: function (method, model, options) {
    if (this.syncMethods[method]) {
      return this.syncMethods[method](method, model, options);
    } else {
      return Backbone.sync(method, model, options);
    }
  },

  storageFallback: function (model, name) {
    try {
      model.prototype.localStorage = new LocalStorage(name);
    } catch (e) {
      model.prototype.localStorage = webStorage;
    }
  },
};

export default SyncService;
